module.exports = __webpack_public_path__ + "img/meal-go.2fbcfb66.png";